<h2 class="wizard_step-title text--title-bold">{{ 'reviewAndConfirm' | translate | titlecase }}</h2>

<div class="review-section">
  <h3 class="review-section_title">{{ 'patient' | translate | titlecase }}</h3>
  <div class="reallocate-notice" *ngIf="patient?.existingPatient">
    <i class="fas fa-info-circle"></i>
    <span>{{ 'usingExistingPatient' | translate }}</span>
  </div>
  <div class="review-row" *ngIf="patient?.summary?.name">
    <span class="review-row_label">{{ (patient.summary.nameLabel || 'name') | translate | titlecase }}</span>
    <span class="review-row_value">{{ patient.summary.name }}</span>
  </div>
  <div class="review-row" *ngIf="patient?.summary?.demographic">
    <span class="review-row_label">{{ patient.summary.demographicLabel | translate | titlecase }}</span>
    <span class="review-row_value">{{ patient.summary.demographic }}</span>
  </div>
  <div class="review-row">
    <span class="review-row_label">{{ 'doctorsName' | translate | titlecase }}</span>
    <span class="review-row_value">{{ patient?.summary?.doctorName }}</span>
  </div>
</div>

<div class="review-section">
  <h3 class="review-section_title">{{ 'device' | translate | titlecase }}</h3>
  <div class="reallocate-notice" *ngIf="device?.mode === 'existing'">
    <i class="fas fa-info-circle"></i>
    <span>{{ 'usingExistingDevice' | translate }}</span>
  </div>
  <div class="review-row">
    <span class="review-row_label">{{ 'name' | translate | titlecase }}</span>
    <span class="review-row_value">{{ deviceName }}</span>
  </div>
  <div *ngIf="device?.reallocate" class="reallocate-notice">
    <i class="fas fa-exclamation-triangle"></i>
    <span>{{ 'reallocateDeviceNotice' | translate }}</span>
  </div>
</div>

<div class="review-section">
  <h3 class="review-section_title">{{ 'networkAndTechnicalDetails' | translate | titlecase }}</h3>
  <div class="review-row">
    <span class="review-row_label">{{ 'hotspotEnabled' | translate }}</span>
    <span class="review-row_value">{{ (network?.hotspot_enabled ? 'yes' : 'no') | translate | titlecase }}</span>
  </div>
  <div class="review-row" *ngIf="network?.hotspot_enabled">
    <span class="review-row_label">{{ 'patientPhoneOs' | translate }}</span>
    <span class="review-row_value">{{ network?.phone_os }}</span>
  </div>
  <div class="review-row">
    <span class="review-row_label">{{ 'homeWifiSsid' | translate }}</span>
    <span class="review-row_value">{{ network?.wifi_ssid }}</span>
  </div>
  <div class="review-row">
    <span class="review-row_label">{{ 'homeWifiPassword' | translate }}</span>
    <span class="review-row_value">{{ network?.wifi_password }}</span>
  </div>
</div>

<div class="wizard_footer">
  <button class="button button--secondary" type="button" [disabled]="isSubmitting" (click)="back.emit()">
    <span class="regular">{{ 'back' | translate }}</span>
  </button>
  <button class="button button--primary" type="button" [disabled]="isSubmitting" (click)="submit.emit()">
    <span class="regular">{{ 'finishSetup' | translate }}</span>
  </button>
</div>

<app-loader *ngIf="isSubmitting"></app-loader>
